import { API_BASE_URL } from './config'

// Matches the backend's error shape: every failure is { error: string } with a
// message already written for a human. See src/backend/modules/admin/*.
export class ApiError extends Error {
	status: number
	constructor(status: number, message: string) {
		super(message)
		this.status = status
		this.name = 'ApiError'
	}
}

interface RequestOptions {
	method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
	body?: unknown
	signal?: AbortSignal
}

export async function apiFetch<T>(path: string, options: RequestOptions = {}): Promise<T> {
	const res = await fetch(`${API_BASE_URL}${path}`, {
		method: options.method ?? 'GET',
		// The admin session is a cookie; without this every request is anonymous.
		credentials: 'include',
		headers: options.body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
		body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
		signal: options.signal,
	})

	const data = await res.json().catch(() => ({}))
	if (!res.ok) {
		throw new ApiError(res.status, (data as { error?: string }).error ?? 'Request failed')
	}
	return data as T
}

// Builds a query string, dropping empty values so the backend sees an absent
// filter rather than an empty one.
export function qs(params: Record<string, string | number | undefined | null>): string {
	const search = new URLSearchParams()
	for (const [key, value] of Object.entries(params)) {
		if (value !== undefined && value !== null && value !== '') search.set(key, String(value))
	}
	const s = search.toString()
	return s ? `?${s}` : ''
}
